<template>
  <div class="services container-fluid">
    <div class="row">
      <Nav></Nav>
      <div class="col-sm-12" id="servicestext">
      <h1 style="font-family: 'Abril Fatface', cursive;">Think of us as your in-house creative department</h1>
      <p>We are a Bangkok based creative production agency.
        Your one stop social media fixer. We understand the practicalities and
        cost of bringing great ideas to life, while delivering the right strategy
        and concept for your brand.
      </p>

      <h1>Monthly Packages</h1>

      <p>Packages allow you to reach your creative goals while meeting your
        quarterly budget. Created with your marketing needs in mind. Engaging
        content and winning campaigns with no-surprise costs.
      </p>

      <ul>
        <li>Range of options & services</li>
        <li>Budget-friendly monthly pricing</li>
        <li>One-stop creative solutions</li>
        <li>Monthly included design hours</li>
      </ul>

      <h4 style="padding-top: 1rem;">Examples of packages and services:</h4>

      <h1>Consistent flow of photo and video content</h1>

      <ul>
        <li>Photoshoot</li>
        <li>Videoshoot</li>
        <li>Unlimited content gathering</li>
        <li>Art direction</li>
        <li>Styling, props + wardrobe</li>
        <li>Model casting + booking</li>
        <li>Editing, post + resizing</li>
        <li>Asset curation</li>
        <li>Full service photo studio</li>
      </ul>

      <h1>Engage on Social Media</h1>

      <ul>
        <li>Content gather photoshoots</li>
        <li>Digital brand guide</li>
        <li>Campaign strategy</li>
        <li>Creative development</li>
        <li>Content calendar</li>
        <li>Sharable content creation</li>
        <li>Social media management</li>
        <li>Email design + development</li>
        <li>Email management</li>
        <li>Reporting</li>
      </ul>

      <h1>Print & Digital Advertising</h1>

      <ul>
        <li>Media plan</li>
        <li>Campaign strategy</li>
        <li>Creative development</li>
        <li>Print advertisement design</li>
        <li>Digital advertisement design</li>
        <li>HTML5 banner ads</li>
        <li>PPC management</li>
        <li>Paid social management</li>
        <li>Unlimited resizing</li>
        <li>Reporting</li>
      </ul>
    </div>
  </div>


  </div>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'

export default {
  name: 'services',
  components: {
    Nav
  }
}
</script>
<style scoped>

.services {
  background-color: #FFBCD9;
  text-align: left;
  font-size: 1rem;
  font-family: 'Roboto', sans-serif;
}

#servicestext {
  color: black;
  margin-top: 3rem;
  padding: 4rem 15rem 0 15rem;
  text-align: justify;
  font-size: 1rem;
}

#servicestext h1 {
  font-family: 'Abril Fatface', cursive;
  line-height: 2;
  text-align: justify;
  font-size: 1rem;

}

#logo {
  width: 16%;
  min-width: 160px;
}

@media (max-width: 500px) {
  .services {
    color: red;
  }
  #servicestext {
    margin-top: 0;
    padding: 1.2rem;
    font-size: 1rem;
  }
  #servicestext h1 {
    line-height: 1.2;
    text-align: left;
    font-size: 1.2rem;
  }
}

@media (width: 320px) {
  #servicestext {
    color: black;
  }
}

@media (min-width: 500px) and (max-width: 1024px) and (orientation: portrait) {

    .services {
      font-size: 2rem;
    }

    #servicestext {
      margin-top: 0;
      padding: 5rem;
      font-size: 1rem;
    }

    #servicestext h1 {
      line-height: 1;
      text-align: left;
      font-size: 2rem;
    }
}

@media (orientation: landscape){
  #servicestext {
    padding: 2.5rem;
    font-size: 1.5rem;
  }
  #servicestext h1 {
    font-size: 2rem;
  }
}

  @media (min-width: 415px) AND (max-width: 1024px) {
    .services {
      font-size: 2rem;
      color: red;
    }
  }

</style>
